import { NgModule } from '@angular/core';
import { AssetFullScreen } from './asset-full-screen';
import { AssetFullScreenComponent } from './asset-full-screen.component';

@NgModule({
  imports: [AssetFullScreenComponent],
  providers: [AssetFullScreen],
})
export class AssetFullScreenModule {}
